import { jsx } from "react/jsx-runtime";
import { overlaySearchHeaderVariants } from "./OverlaySearchHeader.variants.js";
function OverlaySearchHeader({ children }) {
    const { root } = overlaySearchHeaderVariants();
    return /*#__PURE__*/ jsx("div", {
        className: root(),
        children: children
    });
}
export { OverlaySearchHeader };
